import axios from 'axios';
import type { Survey } from '@hotjar/feedback/domain/Surveys/Survey/Survey';

export const getSurveyTemplateById = async (templateId: string): Promise<Survey | null> => {
  return axios
    .get(`/api/v1/survey-templates/${templateId}`)
    .then(({ data }) => data)
    .catch(() => null);
};
